module.exports = require("babel-runtime/helpers/createClass");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/createClass"
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 10 11 16